import { render, staticRenderFns } from "./TabNews.vue?vue&type=template&id=494bd475&scoped=true"
import script from "./TabNews.vue?vue&type=script&lang=js"
export * from "./TabNews.vue?vue&type=script&lang=js"
import style0 from "./TabNews.vue?vue&type=style&index=0&id=494bd475&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "494bd475",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/qhygcg-web-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('494bd475')) {
      api.createRecord('494bd475', component.options)
    } else {
      api.reload('494bd475', component.options)
    }
    module.hot.accept("./TabNews.vue?vue&type=template&id=494bd475&scoped=true", function () {
      api.rerender('494bd475', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/home/components/TabNews.vue"
export default component.exports